<template>
<div style="padding: 5px 5px 15px 5px"> 

<span v-if="contact && contact.mobile">
    <a class="transparent" :href="'tel:' + contact.mobile.replace(/\D/g,'')">    
    <v-tooltip right :disabled="isMobile">
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" large icon outlined color="grey" class="mr-1">
            <v-icon color="grey">phone</v-icon>
        </v-btn>
        </template>
        <span>Call {{contact.mobile | phone}}</span>
    </v-tooltip>
    </a>
</span>

<span v-if="contact && contact.mobile">
    <a class="transparent" :href="'sms://' + contact.mobile.replace(/\D/g,'')">    
        <v-tooltip bottom :disabled="isMobile">
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="showSMS" large icon outlined color="grey" class="mr-1">
                <v-icon color="grey">textsms</v-icon>
            </v-btn>
            </template>
            <span>Send SMS</span>        
        </v-tooltip>
    </a>
</span>

<span v-if="contact && contact.email">
    <v-tooltip bottom :disabled="isMobile">
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" large @click.native.stop="showEmail()" icon outlined color="grey" class="mr-1">
            <v-icon color="grey">email</v-icon>
        </v-btn> 
        </template>
        <span>{{contact.email}}</span>             
    </v-tooltip>
</span>

<span v-if="contact && contact.fax">
    <v-tooltip bottom :disabled="isMobile">
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" large @click.native.stop="showEmail({fax:true})" icon outlined color="grey" class="mr-1">
            <v-icon color="grey">mdi-fax</v-icon>
        </v-btn> 
        </template>
        <span>Fax {{contact.fax | phone}}</span>             
    </v-tooltip>
</span>

<v-tooltip bottom :disabled="isMobile">
    <template v-slot:activator="{ on }">
    <v-btn v-on="on" large @click.native.stop="expandedView = !expandedView" icon outlined color="grey" class="mr-1">
        <v-icon color="grey">account_box</v-icon>
    </v-btn> 
    </template>
    <span>More details</span>             
</v-tooltip>

<!-- Contact Details -->
<div v-if="expandedView" style="color:#666">

<table style="padding:2px">
    <tr>
        <td>
            <ContactImage :contact="contact" :size="80" />
            <!-- <img width="100" class="subtle-shadow" :src="getContactImage(contact)" /> -->
        </td>
        <td>

            <table style="padding:5px">
                <tr v-if="contact.mobile">
                    <td class="title-column">Mobile</td>
                    <td>{{contact.mobile}}</td>
                </tr>
                <tr v-if="contact.phone">
                    <td class="title-column">Phone</td>
                    <td>{{contact.phone}}</td>
                </tr>
                <tr v-if="contact.fax">
                    <td class="title-column">Fax</td>
                    <td>{{contact.fax}}</td>
                </tr>
                <tr v-if="contact.business">
                    <td class="title-column">Business</td>
                    <td>{{contact.business}}</td>
                </tr>
                <tr v-if="contact.email">
                    <td class="title-column">Email</td>
                    <td>{{contact.email}}</td>
                </tr>
                <tr v-if="contact.address">
                    <td class="title-column">Address</td>
                    <td>{{contact.address}}</td>
                </tr>
                <tr v-if="contact.dob">
                    <td class="title-column">DOB</td>
                    <td>{{contact.dob | date}}</td>
                </tr>
                <tr v-if="contact.middleName">
                    <td class="title-column">Middle Name</td>
                    <td>{{contact.middleName}}</td>
                </tr>
                <tr v-if="contact.owner">
                    <td class="title-column">Owner</td>
                    <td>{{fullName(contact.owner)}}</td>
                </tr>
                <tr v-if="contact.groups">
                    <td valign="middle" class="title-column">Groups</td>
                    <td><v-chip small v-for="item in objectToArray(contact.groups)" :key="item" >{{item}}</v-chip> 
                    </td>
                </tr>
                <tr v-if="contact.notes">
                    <td valign="top" class="title-column">Notes</td>
                    <td>{{contact.notes}}</td>
                </tr>
            </table>


        </td>
    </tr>
</table>


</div>

<!-- SMS Box -->
<table v-if="showingSMS" style="width:100%">
<tr>
    <td>
        <v-textarea outline rows="3" v-model="smsMessage" ref="smsText" @keypress.enter.prevent="sendSMSMessage" :label="smsPrefix" :hint="smsSuffix" persistent-hint />    
    </td>
    <td valign="top" style="width:20px">
        <v-menu left :nudge-top="-34" :nudge-left="13" max-height="355">
        <template v-slot:activator="{ on }">
        <v-btn color="grey" text icon v-on="on" href="#"><v-icon>keyboard_arrow_down</v-icon></v-btn>
        </template>
        <v-list>
            <v-list-item v-for="template in templates
            " @click="selectSMSTemplate(template)" :key="template['.key']" >
            <v-list-item-title>{{template.name}}</v-list-item-title>
            </v-list-item>
        </v-list>
        </v-menu>                  
    </td>
</tr>
</table>

<!-- Dialog Components -->
<EmailDialog :settings="emailDialog.settings" :email="emailDialog.email" />

</div>        
</template>

<script>

import TeamHelpers from '../helpers/TeamHelpers'
import EmailDialog from '../ui-elements/EmailDialog'
import Utilities from '../helpers/Utilities'
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import GroupSelector from '../ui-elements/GroupSelector'
import ContactImage from '../flow/ui/ContactImage'



// var db = firebase.database()
// var smsTemplatesRef = db.ref('empty')

export default {
data() {
    return {
        blankAvatars: false,
        smsGroup: 'General SMS',
        smsName: 'General',

        showingSMS: false,
        smsMessage: null,
        smsPrefix: null,
        smsSuffix: null,

        expandedView: this.expanded,

        emailDialog: {
            settings: {
                visible:false,
                group: '',
                template: '',
            },
            email: {
                to: [],
                cc: [],
                bcc: [],
                subject: '',
                body: '',
                attachments: []
            }
        }
    }
},

computed: {
    templates() {
        return this.$store.getters.templates.filter(o => o.group == this.smsGroup)
    },
    isMobile() {
        return Utilities.isMobile()
    },
},

props: {
    contact: Object,
    expanded: Boolean,
},

components: {
    'EmailDialog': EmailDialog,
    'GroupSelector': GroupSelector,
    ContactImage,
},

methods: {

    getContactImage(contact) {
        return ContactHelpers.getContactImage(contact, this.blankAvatars)
    },

    objectToArray(obj) {
        return Utilities.objectToArray(obj)
    },

    updateGroups(groups) {
        console.log('CommunicationBar > updateGroups', groups, this.contact)
        let ref = DataHelpers.getTenantRef().child('contacts').child(this.contact.key).child('groups')
        ref.update(groups)
    },

    fullName(contact) {
        return ContactHelpers.fullName(contact)
    },

    showSMS () {

        if(this.isMobile)
            return

        this.showingSMS = ! this.showingSMS

        if(!this.showingSMS) {
            this.smsMessage = ''
            return
        }

        this.initialiseSMSTemplates()

        let vm = this
        if(!this.smsPrefix) {
            DataHelpers.getSettings('sms').then(function(settings) {
                vm.smsPrefix = settings.prefix || 'Update'
                vm.smsSuffix = settings.suffix || '*** This is a system mobile. Please dont reply ***'
            })                        
        }

        setTimeout(function () {
            vm.$refs.smsText.focus()
        }, 500)
    }, 
    
    toFaxAddress(faxNumber) {
        return Utilities.toFaxAddress(faxNumber)
    },

    sendSMSMessage () {
        console.log('CommunicationBar > sendSMS')
        let mobile = this.contact.mobile
        let message = this.smsMessage
        if(this.smsPrefix)
            message = '(' + this.smsPrefix + ') ' + message
        if(this.smsSuffix)
            message = message +  ' (' + this.smsSuffix + ')'
        Utilities.sendSMS(message, mobile)
        this.smsMessage = ''
        this.showingSMS = false
    },

    showEmail (options) {
        console.log('CommunicationBar > showEmail')

        let recipient = ContactHelpers.simplifyContact(this.contact)
        recipient.key = this.contact.meta.key
        recipient.role = this.contact.meta.role || null

        if(options && options.fax == true)
            recipient = ContactHelpers.createFaxContact(recipient)

        this.emailDialog.email.to = [recipient] 
        this.emailDialog.settings.group = 'General'
        this.emailDialog.settings.template = 'Blank'
        this.emailDialog.returnObject = null
        this.emailDialog.settings.visible = true 
    },

    initialiseSMSTemplates () {
        console.log ('CommunicationBar > initialise')

        
        //load templates

        this.$store.dispatch('loadTemplates').then( () => {
            let template = this.templates.find(o => o.name == (this.smsName || 'General SMS'))
            if(template)
                this.selectSMSTemplate(template)
             else
                console.log('Template not found:', this.smsName)    
        })
    },

    selectSMSTemplate (template) {
        console.log ('CommunicationBar > selectSMSTemplate', template)
        this.smsMessage = template.subject.replace('[greeting]',  ContactHelpers.greetingFromContacts([this.contact]) )
        if(this.$refs.smsText)
            this.$refs.smsText.focus()
    }    

},
created() {
        TeamHelpers.fetchTeamSettings().then(settings => {
            this.blankAvatars = settings.blankAvatars
        })
},

watch: {
    
    //hide sms box when contact changes
    contact : function(newVal) {
        this.showingSMS = false
    }    
}

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// CommunicationBar.vue?e7d11106